import { render, staticRenderFns } from "./withdrawalAccount.vue?vue&type=template&id=60c7df20&scoped=true&"
import script from "./withdrawalAccount.vue?vue&type=script&lang=js&"
export * from "./withdrawalAccount.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalAccount.vue?vue&type=style&index=0&id=60c7df20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7df20",
  null
  
)

export default component.exports